<template>
  <div>
    <section
      :style="{
        backgroundColor: currentBackgroundColor,
        backgroundImage: `url(${currentData.backgroundimage})`,
        position: 'relative'
      }"
      class="hero is-primary is-large gradient"
    >
      <div class="image-overlay"></div>
      <div class="hero-head">
        <nav class="navbar has-background-black-ter is-fixed-top" id="nav" role="navigation" aria-label="main navigation">
          <div class="container">
            <div class="navbar-brand">
              <a class="navbar-item" href="#top">
                <h1 class="logoFont">dh</h1>
              </a>
              <span
                class="navbar-burger burger"
                @click="toggleMobileMenu"
                :class="{'is-active': mobileMenuOpen}"
              >
                <span></span>
                <span></span>
                <span></span>
              </span>
            </div>
            <div :class="{ 'is-active': mobileMenuOpen }" class="navbar-menu">
              <div class="navbar-end is-info">
                <a class="page-scroll navbarItem is-hovered" href="#AboutMe"><strong>About me</strong></a>
                <a class="page-scroll navbarItem is-hovered" href="#WorkExperience"><strong>Work Experience</strong></a>
                <a class="page-scroll navbarItem is-hovered" href="#Skills"><strong>Skills</strong></a>
                <a class="page-scroll navbarItem is-hovered" href="#Projects"><strong>Projects</strong></a>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div class="hero-body">
        <div class="container has-text-centered" id="container">
          <p class="title">{{ currentData.title }}</p>
          <p class="subtitle">{{ currentData.subtitle }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HeroComponent',
  data() {
    return {
      currentIndex: 0,
      dataSets: [
        {
          title: 'Davey Hurkmans',
          subtitle: 'UX / UI Designer',
          backgroundimage: require('@/assets/imgone.jpg'),
        },
        {
          title: 'Davey Hurkmans',
          subtitle: 'Blender and 3D Unity',
          backgroundimage: require('@/assets/imgtwo.jpg'),
        },
        {
          title: 'Davey Hurkmans',
          subtitle: 'Frontend Developer',
          backgroundimage: require('@/assets/imgthree.gif'),
        },
      ],
      mobileMenuOpen: false,
    };
  },

  computed: {
    currentData() {
      return this.dataSets[this.currentIndex];
    },
    currentBackgroundColor() {
      return this.getRandomBlueishPurpleColor();
    },
  },
  methods: {
    toggleMobileMenu() {
      // Toggle mobile menu state
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    getRandomBlueishPurpleColor() {
      const backgroundColors = ['#5C5470', '#6E6494', '#7D4DFE'];
      return backgroundColors[Math.floor(Math.random() * backgroundColors.length)];
    },
    switchData() {
      this.currentIndex = (this.currentIndex + 1) % this.dataSets.length;
    },
  },
  mounted() {
    setInterval(this.switchData, 5000);
  },
};
</script>

<style scoped>
.logoFont {
  font-family: Nabla;
  color: #fff;
  font-size: 300%;
}
.navbar-item {
  font-family: 'Avenir', sans-serif;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(42, 30, 108, 0.8); 
  z-index: 1; 
}

.title {
  font-family: 'Avenir', sans-serif;
  font-size: 6rem;
  z-index: 5;
}
.subtitle {
  font-family: 'Open Sans', sans-serif;
  font-size: 1.5rem;
  z-index: 4;
}
.gradient {
  background: linear-gradient(to right, rgba(107, 77, 168, 0.85) 0%, rgba(73, 119, 194, 0.85) 60%);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: #fff;
}
.overlay {
  background: linear-gradient(to right, rgba(107, 77, 168, 0.85) 0%, rgba(73, 119, 194, 0.85) 100%);
}
.navbarItem {
  margin: auto;
  padding: 2vw;
  padding-bottom: 1vw;
  padding-top: 1vw;
  height: auto;
}
.navbarItem:hover {
  background-color: #4d8bfe;
}

.navbar-item:hover {
  background: linear-gradient(to right, rgba(107, 77, 168, 0.85) 0%, rgba(73, 119, 194, 0.85) 100%);
}

.navbar-burger {
  margin-top: auto;
  margin-bottom: auto;
}

.title, .subtitle {
  position: relative;
  z-index: 2; /* Ensure the text is above the black overlay */
}

@media only screen and (max-width: 1030px) {

  .hero.is-primary .navbar-menu {
  background: linear-gradient(to right, rgba(107, 77, 168, 0.85) 0%, rgba(73, 119, 194, 0.85) 100%);
  background-color: unset;
}

}

@media only screen and (max-width: 768px) {
  .hero-body {
    margin-top: 30vw;
  }

  .title {
    font-size: xxx-large;
  }

  .hero.is-primary .navbar-menu {
  background: linear-gradient(to right, rgba(107, 77, 168, 0.85) 0%, rgba(73, 119, 194, 0.85) 100%);
  }


}


#container {
  color: #fff;
  text-transform: capitalize;
  font-size: 36px;
  font-weight: bold;
  width: 100%;
  bottom: 60%;
}
#flip {
  height: 50px;
  overflow: hidden;
  text-transform: uppercase;
}
#flip > div > div {
  color: #fff;
  padding: 4px 12px;
  height: 45px;
  margin-bottom: 45px;
  display: inline-block;
}
#flip div:first-child {
  animation: show 8s linear infinite;
}
#flip div div {
  background: none;
  color: #d3d3d4;
}
#flip div:first-child div {
  background: none;
  color: #d3d3d4;
}
#flip div:last-child div {
  background: none;
  color: #d3d3d4;
}

.hero img {
  background-color: #111, 50%;
}


@keyframes show {
  0% {
    margin-top: -270px;
  }
  5% {
    margin-top: -180px;
  }
  33% {
    margin-top: -180px;
  }
  38% {
    margin-top: -90px;
  }
  66% {
    margin-top: -90px;
  }
  71% {
    margin-top: 0px;
  }
  99.99% {
    margin-top: 0px;
  }
  100% {
    margin-top: -270px;
  }
}
p {
  width: 100%;
  bottom: 30px;
  font-size: 12px;
  color: #999;
  margin-top: 200px;
}
</style>

